import { useEffect, useState } from 'react';
import { IconDiscord, IconLogo } from '../components/Icons.js';
import { useBranding } from '../lib/branding.js';

export default function Login() {
  const branding = useBranding();
  const [logoFailed, setLogoFailed] = useState(false);
  useEffect(() => { setLogoFailed(false); }, [branding.logo_url]);
  const showCustomLogo = branding.logo_url && !logoFailed;
  return (
    <div className="h-full flex items-center justify-center bg-bg p-4">
      <div className="w-full max-w-md">
        <div className="card p-8 sm:p-10 flex flex-col items-center gap-6 shadow-pop">
          <div className="flex items-center gap-3">
            {showCustomLogo ? (
              <img
                src={branding.logo_url}
                alt=""
                className="rounded-lg object-cover bg-bg-card border border-bg-border"
                style={{ width: 44, height: 44 }}
                onError={() => setLogoFailed(true)}
              />
            ) : (
              <IconLogo size={44} />
            )}
            <div>
              <h1 className="text-xl font-semibold tracking-tight">{branding.name}</h1>
              <p className="text-fg-muted text-xs">{branding.tagline}</p>
            </div>
          </div>

          <p className="text-center text-sm text-fg-muted leading-relaxed max-w-xs">
            Sign in with Discord to manage your fleet. You must be a member of the configured Discord guild.
          </p>

          <a
            href="/api/auth/login"
            className="btn-primary w-full justify-center !h-11 text-base"
          >
            <IconDiscord className="w-5 h-5" />
            Sign in with Discord
          </a>

          <p className="text-[11px] text-fg-dim text-center max-w-xs">
            By signing in, your Discord ID is stored to track sessions and roles.
          </p>
        </div>
      </div>
    </div>
  );
}
